import {Controller} from "stimulus"

/**
 * Auto-populates the due date field when a case template with a due_date_interval
 * is selected on the new planning case form.
 *
 * Attach to the form element. Looks for:
 *   - select[name*="planning_case_template_id"] as the template selector
 *   - input.planning-case-due-date-field as the due date input
 */
export default class extends Controller {

    connect() {
        this.templateSelect = this.element.querySelector("select[name*='planning_case_template_id']")
        this.dueDateField = this.element.querySelector(".planning-case-due-date-field")
        this.currentRequestId = 0
    }

    templateChanged() {
        if (!this.templateSelect || !this.dueDateField) return

        const templateId = this.templateSelect.value
        if (!templateId) {
            this.clearDueDate()
            return
        }

        const requestId = ++this.currentRequestId

        fetch(`/planning/case_templates/${templateId}.json`)
            .then(response => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`)
                return response.json()
            })
            .then(data => {
                if (requestId !== this.currentRequestId) return
                if (data.due_date_interval) {
                    this.setDueDate(data.due_date_interval)
                } else {
                    this.clearDueDate()
                }
            })
            .catch(() => {
                if (requestId !== this.currentRequestId) return
                this.clearDueDate()
            })
    }

    setDueDate(intervalDays) {
        if (!this.dueDateField) return
        const dueDate = new Date()
        dueDate.setDate(dueDate.getDate() + intervalDays)
        const formatted = this.formatDate(dueDate)
        this.dueDateField.value = formatted
        if (this.dueDateField._flatpickr) {
            this.dueDateField._flatpickr.setDate(formatted, false)
        }
    }

    clearDueDate() {
        if (!this.dueDateField) return
        this.dueDateField.value = ""
        if (this.dueDateField._flatpickr) {
            this.dueDateField._flatpickr.clear()
        }
    }

    formatDate(date) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const day = String(date.getDate()).padStart(2, "0")
        return `${year}-${month}-${day}`
    }
}
